// This generates a new module for the Namesapce Matrix42.Utils
angular.module('Matrix42.Utils', []);
